<app-modal
  modalId="exchange-node"
  widthClass="max-w-3xl"
  [showCloseButton]="true"
  [allowEscToClose]="true"
  [closeOnBackdropClick]="true"
>
  <span title>{{ node()?.name ?? 'Exchange' }}</span>

  <div body class="flex flex-col gap-2 max-h-[60vh] overflow-y-auto pr-2">
    @if (node(); as nodeContent) {
      @for (row of rows(); track rowTrack(row)) {
        <div
          class="flex flex-wrap items-center gap-3 rounded-box bg-base-200 p-2"
        >
          @if (row.kind === 'Equipment') {
            <app-slot-armory-item
              class="zoom-row"
              [equipment]="row.inputContent"
              [equipmentItem]="row.item"
            />
            <span
              class="type-entity-name min-w-0 flex-1 text-{{
                row.inputContent.rarity
              }}"
            >
              {{ row.inputName }}
            </span>

            <span class="type-muted">
              <app-icon name="tablerArrowRight"></app-icon>
            </span>

            <app-slot-armory-item
              class="zoom-row"
              [equipment]="row.outputContent"
              [equipmentItem]="row.outputItem"
            />
            <div class="flex min-w-0 flex-1 flex-col">
              <span
                class="type-entity-name text-{{ row.outputContent.rarity }}"
              >
                {{ row.outputName }}
              </span>
              @if (row.losesGems) {
                <span class="badge badge-sm badge-warning">
                  Gems in extra sockets will be lost.
                </span>
              }
            </div>
          } @else {
            <app-row-currency-cost class="flex-1" [costs]="itemInput(row)" />

            <span class="type-muted">
              <app-icon name="tablerArrowRight"></app-icon>
            </span>

            <app-row-currency-cost class="flex-1" [costs]="itemOutput(row)" />

            <div class="flex-1"></div>
          }

          <button
            type="button"
            class="btn btn-xs btn-primary flex-1"
            [disabled]="!isAtNode() || !row.canAfford"
            (click)="perform(row)"
            appSfx="ui-success"
            [sfxTrigger]="['click', 'hover']"
          >
            {{ nodeContent.actionLabel }}
            <app-row-currency-cost
              [costs]="
                row.kind === 'Equipment' ? row.costs : row.exchange.costs
              "
            />
          </button>
        </div>
      } @empty {
        <app-blank-slate>{{ nodeContent.emptyText }}</app-blank-slate>
      }

      @if (showUnequipHint()) {
        <p class="type-muted text-sm">
          Some of your heroes are wearing gear that could be exchanged here.
          Unequip it first.
        </p>
      }
    }
  </div>
</app-modal>
